<template>
  <svg
    class="donut-chart"
    :height="size"
    :width="size"
    :viewBox="`0 0 ${size} ${size}`"
    :transform="`rotate(${rotationStart})`"
  >
    <!-- Base circle -->
    <circle v-bind="center" :r="size / 2" :fill="backgroundColor" />

    <!-- Wedges -->
    <circle v-for="item in wedges" v-bind="item" :key="item.stroke" />

    <!-- Donut circle-->
    <circle :r="size / 6" v-bind="center" :fill="backgroundColor" />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 44,
    },
    dataset: {
      type: Array, // Expects an array of objects with color and value keys
      required: true,
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    rotationStart: {
      type: Number,
      default: -90,
    },
  },
  computed: {
    center() {
      return {
        cx: this.size / 2,
        cy: this.size / 2,
      };
    },
    total() {
      return this.dataset.reduce((sum, { value }) => sum + value, 0);
    },
    wedges() {
      const radius = this.size / 4;
      const strokeWidth = this.size / 2 - 6;
      const circumfrence = 2 * radius * 3.142;
      let trackingRotation = 0;

      return this.dataset.map(({ color, value }) => {
        const percentage = value / this.total;
        const strokeDash = percentage * circumfrence;
        const previousRotation = trackingRotation;
        trackingRotation -= strokeDash;

        return {
          ...this.center,
          fill: 'transparent',
          r: radius,
          stroke: color,
          'stroke-dasharray': `${strokeDash} ${circumfrence}`,
          'stroke-width': strokeWidth,
          'stroke-dashoffset': previousRotation,
        };
      });
    },
  },
};
</script>

<style scoped>
.donut-chart {
  filter: drop-shadow(0px 0px 25px rgba(27, 7, 83, 0.25));
}
</style>
